module.exports = __webpack_public_path__ + "img/5-4.24357f53.svg";